var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.722 10 7.222-6.32v12.64zM8 10l3.444 3.014V6.986z",
    clipRule: "evenodd"
  })));
};
export { SvgChevronLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS43MjIxOSA5Ljk5OTg0TDEyLjk0NDUgMy42ODAzNUwxMi45NDQ1IDE2LjMxOTNMNS43MjIxOSA5Ljk5OTg0Wk04LjAwMDA4IDkuOTk5ODRMMTEuNDQ0NSAxMy4wMTM3TDExLjQ0NDUgNi45ODZMOC4wMDAwOCA5Ljk5OTg0WiIgLz4KPC9zdmc+Cg==";